<template>
  <d-modal
    class="mailing-translations"
    @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('settings.transaltion.addTranslation') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer
          ref="mailing-translation-add-form"
          tag="form">
          <d-row>
            <d-col cols="12">
              <div class="form-group">
                <label>
                  {{ $t('ui.language') }}:
                </label>

                <d-form-select
                  v-model="language_id"
                  :options="languageOptions" />
              </div>
            </d-col>

            <d-col cols="12">
              <div class="form-group">
                <label for="subject">
                  {{ $t('marketing.emailSubject') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="subject"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="subject" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>
            <d-col cols="12">
              <div class="form-group">
                <label>
                  {{ $t('marketing.messageContent') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="content"
                  v-slot="{ errors }">

                  <div :class="{ 'editor-is-invalid': errors.length }">
                    <wysiwyg-editor
                      v-model="content"
                      key="tinymce-editor"
                      :placeholder="$t('marketing.insertMessageContent')" />
                  </div>

                  <div v-if="errors.length" class="invalid-feedback d-block">
                    {{ errors[0] }}
                  </div>

                </validation-provider>
              </div>
            </d-col>
          </d-row>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        <i class="material-icons">add</i>
        {{ $t('ui.save') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import OrderWysiwyg from '@/components/orders/OrderWysiwyg.vue';

export default {
  name: 'mailing-translation-new-popup',
  components: {
    'wysiwyg-editor': OrderWysiwyg
  },
  props: {
    templateId: {
      default: 0,
      type: Number
    },
    languages: {
      default: () => ([]),
      type: Array
    }
  },
  computed: {
    languageOptions () {
      return this.languages.map(language => ({
        value: language.id,
        text: language.name
      }));
    }
  },
  data () {
    return {
      language_id: this.languages[0].id,
      subject: null,
      content: ''
    };
  },
  methods: {
    handleClose (newTranslationID = false) {
      this.$bus.$emit('mailing-translation-new-popup-close', newTranslationID);
    },
    validateForm () {
      FormUtils.validate(this.$refs['mailing-translation-add-form'], this.saveTranslation);
    },
    saveTranslation () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/marketing/mailings/translations/store',
        formData: {
          language_id: this.language_id,
          template_id: this.templateId,
          subject: this.subject,
          content: this.content
        },
        successTitle: this.$t('settings.transaltion.addTranslationSuccessTitle'),
        successText: this.$t('settings.transaltion.addTranslationSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.transaltion.addTranslationErrorText'),
        successAction: res => {
          this.$bus.$emit('mailing-reload-translations');
          this.handleClose(res.id);
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>

<style>
@media (min-width: 576px) {
  .mailing-translations .modal-dialog {
    max-width: calc(100% - 220px);
  }
}
</style>
